import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Icon from '@component/icon';
import I18n from '@module/i18n';

const TIMEOUT = 15 * 1000; // 15 seconds

export class PanelLoading extends React.Component {
  state = {
    mightBeBorked: false,
  };

  componentDidMount() {
    this.timer = setTimeout(() => {
      this.setState({ mightBeBorked: true });
    }, TIMEOUT);
  }

  componentDidUpdate() {
    if (this.props.onRefresh) {
      if (!this.textNode) {
        return;
      }
      if (!this.textNode.querySelector('a')) {
        return;
      }

      this.textNode.querySelector('a')['onclick'] = this.props.onRefresh;
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  render() {
    let takingTooLong;
    const { route, failed } = this.props;

    if (this.state.mightBeBorked || failed) {
      takingTooLong = (
        <p
          ref={(node) => (this.textNode = node)}
          dangerouslySetInnerHTML={{
            __html: I18n.t('panel.loading_error', {
              path: route.path,
            }),
          }}
        />
      );
    }

    return (
      <div className="panel__loading">
        <Icon type="Loading" />
        {takingTooLong}
      </div>
    );
  }
}

PanelLoading.propTypes = {
  failed: PropTypes.bool,
  onRefresh: PropTypes.func.isRequired,
  route: PropTypes.object.isRequired,
};

PanelLoading.defaultProps = {
  onRefresh: (e) => {
    window.location.reload();
    e.preventDefault();
    return false;
  },
};

const mapStateToProps = ({ route }) => ({ route });

export default connect(mapStateToProps, null)(PanelLoading);
